const FabricationCategory = `
  id
  name
`;

export default FabricationCategory;
